import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Button } from '../styles/StyledComponents';

const HeroSection = styled.section`
  height: 100vh;
  min-height: 600px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, var(--light-blue) 0%, var(--primary-blue) 100%);
  padding: 0;
`;

const HeroContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
  position: relative;
  z-index: 2;
`;

const HeroContent = styled.div`
  max-width: 650px;
  color: var(--white);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const HeroTitle = styled(motion.h1)`
  font-size: 3.5rem;
  margin-bottom: 1rem;
  color: var(--white);
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const HeroSubtitle = styled(motion.p)`
  font-size: 1.5rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const HeroButton = styled(Button)`
  background-color: var(--white);
  color: var(--primary-blue);
  
  &:hover {
    background-color: var(--light-blue);
    color: var(--dark-blue);
  }
`;

const BackgroundShape = styled(motion.div)`
  position: absolute;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  
  &.shape1 {
    width: 300px;
    height: 300px;
    top: -100px;
    right: -50px;
  }
  
  &.shape2 {
    width: 200px;
    height: 200px;
    bottom: 50px;
    right: 100px;
  }
  
  &.shape3 {
    width: 150px;
    height: 150px;
    bottom: -50px;
    left: 10%;
  }
`;

const Hero: React.FC = () => {
  return (
    <HeroSection id="home">
      <BackgroundShape 
        className="shape1"
        animate={{ 
          y: [0, 20, 0],
          rotate: [0, 5, 0]
        }}
        transition={{ 
          duration: 8, 
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      <BackgroundShape 
        className="shape2"
        animate={{ 
          x: [0, 15, 0],
          rotate: [0, -5, 0]
        }}
        transition={{ 
          duration: 10, 
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      <BackgroundShape 
        className="shape3"
        animate={{ 
          y: [0, -20, 0],
          rotate: [0, 10, 0]
        }}
        transition={{ 
          duration: 12, 
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      
      <HeroContainer>
        <HeroContent>
          <HeroTitle
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Hello, I am Karen!
          </HeroTitle>
          <HeroSubtitle
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Empowering Healthcare Through Precision, Adaptability, and a Commitment to Excellence
          </HeroSubtitle>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <HeroButton as="a" href="/assets/cv/karen_lorca_cv.pdf" download="Karen_Lorca_CV.pdf">
              Download My CV
            </HeroButton>
          </motion.div>
        </HeroContent>
      </HeroContainer>
    </HeroSection>
  );
};

export default Hero;
